import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class AdminServices extends Component {

  static async getClientInformation() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/mfa`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getEditClientInformation() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/mfa/clear`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async saveClientInformation(payload) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/mfa`);
    let resp = await axios.post(
      url,
      payload,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getMasterClientInformation() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/profile/full`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  //Edit
  static async getMemberDetailsEditInformation() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/profile/clear`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getMemberDetailsInformation() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/profile`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getDocumentCategories() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/document/category`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getDocumentsByCategory(payload) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/document/listing`);
    let resp = await axios.post(
      url,
      payload,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getDocumentContentByDocId(docId) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/document/content?docId=`+docId);
    let resp = await axios.get(
      url,          
      {
        responseType: 'blob',
        headers: header,
      }
    );    
    return resp;
  }

  static async saveMemberInformation(payload) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/userInfo/profile`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async requestOTP(payload) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/mfa/request`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async verifyOTP(payload) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/mfa/verify`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  

  
  
  //newContact
  static async newContact() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/new`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async newModule(module) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${module}/new`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getContact details
  static async getContact(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/detail`);
    let resp = await axios.post(
      url,
      {
        id:id
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateQuotation
  static async generateQuotation(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/quotation/generate?quotationId=${id}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //saveContact details
  static async saveContact(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/update`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateDocuments for quotation
  static async generateDocuments(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/quotation/generate?quotationId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //deleteContactById
  static async deleteContactById(id,payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/delete?id=${id}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //softDeleteClientById when updated old contact with changed in fields
  static async softDeleteClientById(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/softDeleteClient?clientId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getListing for Contact module
  static async getListing(
    payload,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/listing?value=${searchCriteria}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getListingForAgentManagent(
    payload,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/agentListing`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getListingForFileUpload(
    payload,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/fileUpload/listing`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  static async getTrackErrorsDetails(
    fileId
  ) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/fileUpload/errorLog?id=`+fileId);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  
  static async getFileDetails(
    fileId
  ) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/fileUpload/view?id=`+fileId);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  

  static async getAgentDetails(
    agentId
  ) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/agentDetail?agentId=`+agentId);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getCountAgentRole() {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/dashboard/count`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async findAgent(
    agentId
  ) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/findAgent?agentId=${agentId}`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async addNewAgent(
    payload
  ) {  
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/addAgent`);
    let resp = await axios.post(
      url,
      payload,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async getSupervisorList(segment) {    
    let header = await BaseWebService.standardHeaders();
    header.ChannelId=segment;
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/supervisorListing`);
    let resp = await axios.get(
      url,      
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async updateNewRole(payload) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/updateAgentRole`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  
  static async uploadFile(payload) {        
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    header['Content-Type'] = 'multipart/form-data'
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/fileUpload/upload`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );    
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  
  static async deleteFileUpload(fileId) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/fileUpload/delete?id=`+fileId);
    let resp = await axios.post(
      url, 
      {},     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }
  
  static async deleteAgent(payload) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/deleteAgent`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async deleteSignature(payload) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/deleteSignature`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async deleteUOBStamp(payload) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/deleteStampImage`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  static async updateNewSupervisor(payload) {    
    let header = await BaseWebService.standardHeaders();
    header.UserId=sessionStorage.getItem("adminAgentID")
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/agentManagement/updateAgentSupervisor`);
    let resp = await axios.post(
      url, 
      payload,     
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);    
    return response;
  }

  

  

  

  
}
